import styled, { css } from 'styled-components';
import { getCssByAppBreakpoint } from 'utils/styles.utils';
import { CommonStackProps } from './Stack.interface';

export const Container = styled.div<CommonStackProps>`
  display: flex;
  ${({ flex, wrap, direction, justify, align, gap, isFullWidth }) => css`
    ${flex && getCssByAppBreakpoint('flex', flex)}
    ${direction && getCssByAppBreakpoint('flex-direction', direction)}
    ${align && getCssByAppBreakpoint('align-items', align)}
    ${justify && getCssByAppBreakpoint('justify-content', justify)}
    ${gap && getCssByAppBreakpoint('gap', gap, (value) => `${value}px`)}
    ${isFullWidth && 'width: 100%;'}
    ${wrap && 'flex-wrap: wrap;'}
  `};
`;
